<template>
  <b-modal
      ref="modal"
      id="allocations-modal"
      title="Allocations"
      hide-footer
      size="lg"
  >
    <div class="modal-body text-center font-weight-bold">
        <b-table
            striped
            responsive
            class="table-scroll tbl-lrg"
            :fields="fields"
            :items="allocationsMapped"
            show-empty
            empty-text="No allocations found"
        >
          <template slot="Created" slot-scope="data">{{data.item.Created | formatDate}}</template>
          <template slot="AllocationEvent" slot-scope="data">{{data.item.AllocationEvent}}</template>
          <template slot="Amount" slot-scope="data">{{data.item.Amount | currency}}</template>
        </b-table>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue';
import _filters from '@/mixins/filters.js';
import snotifyHttpError from '@/mixins/snotifyHttpResponses';

export default {
  name: 'AllocationsTable',
  mixins: [snotifyHttpError, _filters],
  props: {
    transactionId: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      allocations: [],
      isLoading: false,
      fields: {
        Created: {
          label: 'Date',
          sortable: true
        },
        AllocationEvent: {
          label: 'Allocation Event',
          sortable: true
        },
        Amount: {
          label: 'Amount',
          sortable: true,
        }
      }
    };
  },

  watch: {
    transactionId: {
      immediate: true,
      handler: 'getAllocations'
    }
  },

  computed: {
    URL() {
      return `https://${Vue.config.honeycomb.moneybot.domain}/api/v1/allocations`;
    },
    account() {
      return this.$store.state.customers.account;
    },
    allocationsMapped() {
      return this.allocations.map(allocation => ({
        Created: allocation.Created,
        AllocationEvent: this.getAllocationEvent(this.transactionId, allocation),
        Amount: allocation.Amount
      }));
    }
  },

  methods: {
    async getAllocations() {
      this.isLoading = true;
      this.allocations = []; // Clear previous data

      try {
        const response = await this.$http.get(
            `${this.URL}/${this.account.Id}/${this.transactionId}`,
            { withCredentials: true }
        );
        this.allocations = response.data.Records || [];
      } finally {
        this.isLoading = false;
      }
    },

    getAllocationEvent(transactionId, allocation) {
      if (transactionId === allocation.AllocatedFromId || transactionId === allocation.AllocatedToId) {
        return `From ${allocation.AllocatedFromType} Transaction ${allocation.AllocatedFromId} to ${allocation.AllocatedToType} Transaction ${allocation.AllocatedToId}`;
      }
    }
  }
};
</script>